import uniq from 'lodash/uniq';
import get from 'lodash/get';

const fp = {
    get,
    uniq,
};

export default fp;
